export function parseCoachingPlan(value) {
  try {
    const plan = typeof value === 'string' ? JSON.parse(value) : value
    return plan && typeof plan === 'object' && !Array.isArray(plan) ? plan : null
  } catch (_) { return null }
}

export function parseCoachingHistory(value) {
  try {
    const history = typeof value === 'string' ? JSON.parse(value) : value
    return Array.isArray(history) ? history.map(parseCoachingPlan).filter(Boolean) : []
  } catch (_) { return [] }
}

export function coachingMoney(value) {
  if (value === null || value === undefined || value === '') return 'Unset'
  const amount = Number(value)
  return Number.isFinite(amount) ? `$${amount.toFixed(2)}` : 'Unset'
}

export function formatCoachingPlanName(planName, fallback = 'Unset') {
  if (planName === 'STANDARD 3 MONTHS' || planName === 'DISCOUNTED 3 MONTHS') {
    return 'Pilot Nutrition (3 months)'
  }

  const match = typeof planName === 'string' && planName.match(/^(?:DISCOUNTED )?PILOT NUTRITION( \+ EXERCISE)? (1|3|6|9|12) MONTHS?$/)
  if (!match) return planName || fallback
  const plan = match[1] ? 'Pilot Nutrition + Exercise' : 'Pilot Nutrition'
  const months = Number(match[2])
  return `${plan} (${months} ${months === 1 ? 'month' : 'months'})`
}

export function coachingPlanMonths(plan) {
  const months = Number(plan && plan.months)
  if (Number.isInteger(months) && months > 0) return months
  const match = plan && typeof plan.plan_name === 'string' && plan.plan_name.match(/ (\d+) MONTHS?$/)
  return match ? Number(match[1]) : null
}

export function coachingBilling(plan) {
  if (plan.monthly !== true) return 'Pay in full'
  const months = coachingPlanMonths(plan) || 3
  return `${months} monthly ${months === 1 ? 'payment' : 'payments'} of ${coachingMoney(plan.monthly_price)}`
}

export function coachingPaymentId(plan) {
  return plan.monthly === true ? `Subscription ID: ${plan.subscription_id || 'Unset'}` : `Transaction ID: ${plan.transaction_id || 'Unset'}`
}
